module.exports = __webpack_public_path__ + "img/orng_3.65b43f08.jpg";